import React, { useState } from "react";
import {
  decodeWysiwygHtml,
  looksLikeHtml,
  planCopy,
  planHasExpandableCopy,
  planLeadText,
  planPlainDescription,
} from "../../Data/billingPlans";

const WysiwygHtml = ({ html, className }) => {
  const decoded = decodeWysiwygHtml(html);
  if (!decoded) return null;
  if (!looksLikeHtml(decoded)) {
    return <p className={className}>{decoded}</p>;
  }
  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{ __html: decoded }}
    />
  );
};

export const PlanRichCopy = ({
  plan,
  htmlClassName,
  descClassName,
  listClassName,
}) => {
  const copy = planCopy(plan);
  return (
    <>
      {copy.html ? (
        <WysiwygHtml html={copy.html} className={htmlClassName} />
      ) : copy.description ? (
        <p className={descClassName}>{copy.description}</p>
      ) : null}
      {copy.features.length > 0 ? (
        <ul className={listClassName}>
          {copy.features.map((feature, index) => (
            <li key={`${index}-${feature.slice(0, 24)}`}>
              {looksLikeHtml(feature) ? (
                <WysiwygHtml html={feature} />
              ) : (
                feature
              )}
            </li>
          ))}
        </ul>
      ) : null}
    </>
  );
};

export const PlanPlainCopy = ({ plan, className, maxLength = 140 }) => {
  const text = planPlainDescription(plan, maxLength);
  if (!text) return null;
  return <p className={className}>{text}</p>;
};

export const PlanCollapsedCopy = ({
  plan,
  excerptClassName,
  htmlClassName,
  listClassName,
  moreClassName,
  previewClassName,
}) => {
  const [open, setOpen] = useState(false);
  const lead = planLeadText(plan, 0);
  const expandable = planHasExpandableCopy(plan);

  if (!lead && !expandable) return null;

  const body = (
    <PlanRichCopy
      plan={plan}
      htmlClassName={htmlClassName}
      descClassName={excerptClassName}
      listClassName={listClassName}
    />
  );

  return (
    <>
      {open ? (
        body
      ) : expandable && previewClassName ? (
        <div className={previewClassName}>{body}</div>
      ) : lead ? (
        <p className={excerptClassName}>{lead}</p>
      ) : (
        body
      )}
      {expandable ? (
        <button
          type="button"
          className={moreClassName}
          aria-expanded={open}
          onClick={(event) => {
            event.stopPropagation();
            setOpen((current) => !current);
          }}
        >
          {open ? "View less" : "View more"}
        </button>
      ) : null}
    </>
  );
};

export default WysiwygHtml;
